import { SxProps, Theme } from '@mui/material';

export const boxStyles: SxProps<Theme> = {
  display: 'flex',
};

export const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export const linkStyles: SxProps<Theme> = {
  cursor: 'pointer',
};

export const containerStyles: SxProps<Theme> = {
  maxHeight: '50vh',
  minHeight: '100px',
};

export const sortStyles: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
};

export const infoWidgetContentStyles: SxProps<Theme> = {
  padding: 2,
};

export const widgetContainerStyes: SxProps<Theme> = {
  backgroundColor: '#eeeeee',
};

export const mainContentStyles: SxProps<Theme> = {
  padding: 2,
};

export const tableContainerStyles: SxProps<Theme> = {
  paddingTop: 2,
};

export const buttonContainerStyles: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
};

export const headerContentStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  flexFlow: 'row',
};

export const tableContentStyles: SxProps<Theme> = {
  paddingTop: 2,
};

export const metricContentStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%',
};
